  const openModalHombre = document.getElementById("openModal-hombre");
  if (openModalHombre) {
    openModalHombre.onclick = function () {
      document.getElementById("modal-hombre").style.display = "block";
      document.body.classList.add("modal-open");
    };
  }
  
  document.getElementById("closeModal-hombre").onclick = function() {
    document.getElementById("modal-hombre").style.display = "none";
    document.body.classList.remove("modal-open");
  };
  
  window.onclick = function(event) {
    if (event.target == document.getElementById("modal-hombre")) {
      document.getElementById("modal-hombre").style.display = "none";
      document.body.classList.remove("modal-open");
    }
  };
  
  function openTabtHombre(event, tabId) {
    const tabs = document.querySelectorAll(".tab-content-hombre");
    tabs.forEach(tab => tab.style.display = "none");
  
    document.getElementById(tabId).style.display = "block";
  
    const tabLinks = document.querySelectorAll(".tab-link-hombre");
    tabLinks.forEach(link => link.classList.remove("active"));
  
    event.currentTarget.classList.add("active");
    //console.log("hice click en la pestana");
  }

 document.addEventListener("DOMContentLoaded", () => {
    openTabtHombre({ currentTarget: document.querySelector(".tab-link-hombre") }, "hoodie-hombre");
    showSlide(0);
  });
  